import uuid from 'uuid/v4';
import getPostsByType from '../../../../api/graphql/queries/getPostsByType';

const items = [];
const allItems = [];

const reusableItems = [];

// Add reusable components to items
getPostsByType('component')
  .then((res) => {
    if (res) {
      const { posts } = res;
      Object.keys(posts).forEach((post) => {
        const mod = {
          id: uuid(),
          content: posts[post].slugName,
          readableName: posts[post].slugName,
          type: 'reusableItem',
        };
        items.push(mod);
        reusableItems.push(mod);
      });
    }
  })
  .catch((err) => {
    console.log('TCL: err', err);
  });

// Add componentes to items

const componentDefinitions = [
  { content: 'Carousel', category: 'media', readableName: 'Carousel' },
  { content: 'CarouselWithDescription', category: 'media', readableName: 'Carousel with Description' },
  { content: 'Gallery', category: 'media', readableName: 'Gallery' },
  { content: 'MediaDescription', category: 'media', readableName: 'Image' },
  { content: 'Postal', category: 'media', readableName: 'Postal' },
  { content: 'LoginPaywall', category: 'extra', readableName: 'Login Paywall' },
  { content: 'FanSaleSignup', category: 'extra', readableName: 'Fan Sale Signup' },
  { content: 'Wishlist', category: 'extra', readableName: 'Wishlist' },
  { content: 'RadioChannel', category: 'media', readableName: 'Radio Channel' },
  { content: 'PosterRow', category: 'media', readableName: 'Poster Row' },
  { content: 'LogosRowModule', category: 'media', readableName: 'Logos Row' },
  { content: 'Pdf', category: 'media', readableName: 'Pdf' },
  { content: 'PostDescriptionRow', category: 'media', readableName: 'Media Row' },
  { content: 'VideoPlayer', category: 'media', readableName: 'Video Player' },
  { content: 'AudioPlayer', category: 'media', readableName: 'Audio Player' },
  { content: 'NativeVideoPlayer', category: 'media', readableName: 'Native Video' },
  { content: 'RadioEpisodesList', category: 'media', readableName: 'Episode list' },
  { content: 'RadioShows', category: 'media', readableName: 'Radio show list' },

  { content: 'StreamModule', category: 'stream', readableName: 'Stream Container' },
  { content: 'BannerModule', category: 'stream', readableName: 'Banner Container' },
  // { content: 'ZoneSection', category: 'stream', readableName: 'Zone Container' },

  { content: 'TitleLineH1', category: 'text', readableName: 'TitleH1' },
  { content: 'TitleLineH2', category: 'text', readableName: 'TitleH2' },
  { content: 'TitleLineH3', category: 'text', readableName: 'TitleH3' },
  { content: 'MediaTitle', category: 'text', readableName: 'Double Title' },
  { notDone: true, content: 'NormalBodyText', category: 'text', readableName: 'Paragraph' },
  { content: 'FullLink', category: 'text', readableName: 'Link' },
  { notDone: true, content: 'NumberedList', category: 'text', readableName: 'Numbered List' },


  { notDone: true, content: 'BannersRow', category: 'extra', readableName: 'Multiple Ads block' },
  { content: 'BrazeTrigger', category: 'extra', readableName: 'Braze Log Event' },
  { content: 'GroupedItems', category: 'extra', readableName: 'Grouped Items' },
  { content: 'SearchBasicLayout', category: 'extra', readableName: 'Search block' },
  { notDone: true, content: 'FilterBlock', category: 'extra', readableName: 'Filter Block' },
  { content: 'LineupList', category: 'extra', readableName: 'Artists List' },
  { content: 'CollapsibleList', category: 'extra', readableName: 'Collapsible' },
  { content: 'LineupContainerSimple', category: 'extra', readableName: 'Collapsible FAQs' },
  { content: 'ContactFormReusable', category: 'extra', readableName: 'Contact Form' },
  { content: 'FilterContainer', category: 'extra', readableName: 'Filter' },
  { content: 'IframeComponent', category: 'extra', readableName: 'Iframe' },
  { content: 'InstructionsSimpleUploadLogo', category: 'extra', readableName: 'Instructions' },
  { content: 'Launcher', category: 'extra', readableName: 'Launcher' },
  { content: 'Launcher2', category: 'extra', readableName: 'Launcher2' },
  { content: 'Map', category: 'extra', readableName: 'Map' },
  { content: 'MainNavMenu', category: 'extra', readableName: 'Main Nav Menu' },
  { content: 'RegistrationConfig', category: 'extra', readableName: 'Registration Config' },
  { content: 'MapBox', category: 'extra', readableName: 'MapBox' },
  { content: 'SpotifyPlayer', category: 'extra', readableName: 'SpotifyPlayer' },
  { content: 'CarouselTickets', category: 'extra', readableName: 'Tickets' },
  { content: 'CardsTickets', category: 'extra', readableName: 'Tickets Cards' },
  { content: 'TagsRow', category: 'extra', readableName: 'Tags Row' },
  { content: 'LineupContainer', category: 'extra', readableName: 'Lineup Container' },
  { content: 'ArtistsCloud', category: 'extra', readableName: 'Artists Cloud' },
  { content: 'TestAB', category: 'extra', readableName: 'Test AB' },
  { content: 'ReusableComponent', category: 'extra', readableName: 'Pure Reusable Component' },
  { content: 'NewsLetterSettingsModule', category: 'extra', readableName: 'Newsletter settings' },
  { content: 'NewsletterSubscribeWidgetReusable', category: 'extra', readableName: 'Newsletter widget' },
  { content: 'OnDemandAccessButtonSimple', category: 'extra', readableName: 'Stream Access Button Simple' },
  { content: 'SimpleOnDemandBanner', category: 'extra', readableName: 'Stream Access Banner Simple' },
  { content: 'ProOnDemandAccessButton', category: 'extra', readableName: 'Pro Life Access Button' },
  { content: 'RedtktAccessButton', category: 'extra', readableName: 'Redtkt Access Button' },
  { content: 'MultioptionsButtons', category: 'extra', readableName: 'Multiple Buttons' },
  { content: 'LineupIsOnNow', category: 'extra', readableName: 'Lineup happening today' },
  { content: 'Calendar', category: 'extra', readableName: 'Calendar' },

  { content: 'Separator', category: 'anchor', readableName: 'Separator' },
  { notDone: true, content: 'TaggedItem', category: 'anchor', readableName: 'Category Link' },


  { content: 'AuthorBlock', category: 'anchor', readableName: 'Author Block', placeholder: true, },
  { content: 'DateBlock', category: 'anchor', readableName: 'Post Date', placeholder: true, },
  { content: 'MagazineBlock', category: 'anchor', readableName: 'Related Magazine', placeholder: true, },
  { notDone: true, content: 'TagsBlock', category: 'anchor', readableName: 'Post Tags' },
  { notDone: true, content: 'SharingBlock', category: 'anchor', readableName: 'Sharing Links' },
  { notDone: true, content: 'SocialLogosContainer', category: 'anchor', readableName: 'Social Links' },
  { content: 'Newsletter', category: 'extra', readableName: 'Newsletter Form' },
  { notDone: true, content: 'TicketBlock', category: 'extra', readableName: 'Paywall item' },

  { notDone: true, content: 'ExplodedModule', category: 'text', readableName: 'Exploded view' },
  { content: 'BackCatalogue', category: 'text', readableName: 'Back Catalogue' },

  { content: 'CommentsBox', category: 'extra', readableName: 'Comments Box', placeholder: true, },
  { content: 'TableList', category: 'extra', readableName: 'Table List' },

  { content: 'PdfMagazineGallery', category: 'extra', readableName: 'PDF Magazine Gallery' },
  { content: 'TicketsTabs', category: 'extra', readableName: 'Tickets Tabs' },
  { content: 'Embed', category: 'extra', readableName: 'Embed' },
  { content: 'CustomHtml', category: 'extra', readableName: 'Custom HTML (JS)' },

  { content: 'MapData', category: 'extra', readableName: 'Map - App' },

  { content: 'ImageWrapper', category: 'extra', readableName: 'ImageWrapper' },
  { content: 'SimpleScheduleTable', category: 'extra', readableName: 'Simple Schedule Table' },
  { content: 'Countdown', category: 'extra', readableName: 'Countdown' },
  { content: 'WideBanner', category: 'extra', readableName: 'Wide Banner', apps: ['rdl'] },
];

/*
 * This admin is shared by ps and rdl, but a block's renderer is not: ps-front
 * compiles only src/components/<app>/, so a block whose renderer lives under
 * rdl/ would save fine on ps and then render nothing. A definition may declare
 * `apps` to say which brands offer it; without it, both do, so every existing
 * block is unaffected.
 */
const components = componentDefinitions.filter(
  (comp) => !comp.apps || comp.apps.includes(process.env.APP_NAME),
);

components.forEach((comp) => {
  const mod = {
    id: uuid(),
    content: comp.content,
    readableName: comp.readableName,
    type: 'item',
    placeholder: comp.placeholder ? comp.placeholder : false,
  };
  items.push(mod);
  allItems.push(mod);
});

// anchor items
const anchorItems = [];
const componentsAnchor = components.filter((o) => (o.category === 'anchor'));

componentsAnchor.forEach((comp) => {
  const mod = {
    id: uuid(),
    content: comp.content,
    readableName: comp.readableName,
    type: 'item',
    placeholder: comp.placeholder ? comp.placeholder : false,
  };
  anchorItems.push(mod);
});

// text items
const textItems = [];
const componentsText = components.filter((o) => (o.category === 'text'));

componentsText.forEach((comp) => {
  const mod = {
    id: uuid(),
    content: comp.content,
    readableName: comp.readableName,
    type: 'item',
    placeholder: comp.placeholder ? comp.placeholder : false,
  };
  textItems.push(mod);
});

const mediaItems = [];

const componentsMedia = components.filter((o) => (o.category === 'media'));


componentsMedia.forEach((comp) => {
  const mod = {
    id: uuid(),
    content: comp.content,
    readableName: comp.readableName,
    type: 'item',
    placeholder: comp.placeholder ? comp.placeholder : false,
  };
  mediaItems.push(mod);
});

const mediaItemsStreaming = [];
const componentsMediaStreaming = components.filter((o) => (o.category === 'media' || o.category === 'stream'));

componentsMediaStreaming.forEach((comp) => {
  const mod = {
    id: uuid(),
    content: comp.content,
    readableName: comp.readableName,
    type: 'item',
    placeholder: comp.placeholder ? comp.placeholder : false,
  };
  mediaItemsStreaming.push(mod);
});

const extraItems = [];
const componentsExtra = components.filter((o) => (o.category === 'extra'));

componentsExtra.forEach((comp) => {
  const mod = {
    id: uuid(),
    content: comp.content,
    readableName: comp.readableName,
    type: 'item',
    placeholder: comp.placeholder ? comp.placeholder : false,
  };
  extraItems.push(mod);
});

export {
  anchorItems, textItems, mediaItems, extraItems, reusableItems, mediaItemsStreaming, allItems,
};

export default items;
